import { useTranslation } from "react-i18next";

interface SessionsErrorProps {
  error: Error;
}

export function SessionsError({ error }: SessionsErrorProps) {
  const { t } = useTranslation();
  
  return (
    <div className="bg-red-50 border border-red-200 text-red-800 rounded-lg p-4">
      {t("sessions.error")} {error.message}
    </div>
  );
}